export const environment = {
  production: true,
  environment: 'Production',
  apiEndpoint: 'https://ptsg-1prspwb02.azurewebsites.net/api/',
  authority: "https://login.microsoftonline.com/3b2e8941-7948-4131-978a-b2dfc7295091",
  redirectUri: "https://pranspan.petronas.com/",
  postLogoutRedirectUri: "https://pranspan.petronas.com/",
  clientId: "4ce6f911-8b4c-4230-9944-0a5f5cb1fafe", //"7327d9ef-d2aa-48d6-a2cd-4457951ba7c7", 
  storageEnvironment: "production",
  isCommercialization: false,
  companyAddress: "Level 9, Tower 3, PETRONAS Twin Towers, Kuala Lumpur City Centre, 50088 Kuala Lumpur, Malaysia",
  companyName: "PETROLIAM NASIONAL BERHAD (PETRONAS)",
  azureBlobAccountCommercial: "ptazsg1potfstrlrs2",
  azureBlobAccount: "ptsg1prspstrg",
  vaultEncryptorKey: "2019237462128465",
  vaultEncryptorIV: "3948274634510234"
};
